import { wellnessApi } from "@/apis/interceptor"
import { IQuestionnaireSubmission, IQuestionnaireSubmissionDto, IResponse } from "@/types"

export const questionnaireSubmissionService = {
  createQuestionnaireSubmission: async (dto: IQuestionnaireSubmissionDto): Promise<IResponse<IQuestionnaireSubmission>> => {
    const response = await wellnessApi.post<IResponse<IQuestionnaireSubmission>>("/v1/questionnaire-submissions", dto)
    return response.data
  },
}
